module.exports = __webpack_public_path__ + "static/media/hemp-plant.714fd3d8.jpg";